module.exports = __webpack_public_path__ + "img/yourchance.ccc44e05.svg";